import React from 'react';
import Button from '../../../../../muiComponents/Button';
import useTranslate from '../../../../../customHooks/useTranslate';

interface ImageUploadActionsProps {
    inputId: string;
    inputRef: React.RefObject<HTMLInputElement>;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onRemove: () => void;
    uploadLabel: string;
    showRemove?: boolean;
}

const ImageUploadActions = ({
    inputId,
    inputRef,
    onChange,
    onRemove,
    uploadLabel,
    showRemove = true,
}: ImageUploadActionsProps) => {
    const translate = useTranslate();

    return (
        <div className='flex gap-20'>
            <input
                id={inputId}
                ref={inputRef}
                type='file'
                accept='image/*'
                onChange={onChange}
                hidden
            />
            <Button
                startIcon='FileUploadOutlined'
                variant='outlined'
                size='small'
                onClick={() => inputRef.current?.click()}
            >
                {uploadLabel}
            </Button>
            {showRemove && (
                <Button
                    startIcon='Delete'
                    variant='outlined'
                    color='secondary'
                    size='small'
                    onClick={onRemove}
                >
                    {translate('remove')}
                </Button>
            )}
        </div>
    );
};

export default ImageUploadActions;
